/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.scss';
import Footer from './Components/Footer/Footer';
import Header from './Components/Header/Header';
import Loader from './Components/Loader/Loader';
import { detectMobile } from './Helpers/BrowserDetectionHelper';
import { useAppDispatch, useAppSelector } from './Redux/hooks';
import { allcontentOrConfigData, changeRedirectUrl, storeBannerData, storeContentOrConfig } from './Redux/Reducers/GlobalSlice';
import Router from './Routing/Router';
import { CONTENT_OR_CONFIG_TABLE_MAPPING } from './utils/constants';
import { getKeyValuePair } from './utils/ContentOrConfigUtil';
import { bannerStringGenerator } from './utils/validation';
function App() {
  const dispatch: any = useAppDispatch();
  const loading = useAppSelector((state: any) => state?.global?.loading);
  const id = useAppSelector((state: any) => state?.global?.id);
  let _role = useAppSelector((state: any) => state?.global?.role) || "";
  let _mode = useAppSelector((state: any) => state?.global?.mode) || "";
  let _managedEquipment = useAppSelector((state: any) => state?.global?.managedEquipment);
  const isMobile = detectMobile();
  const contentOrConfigData: any = useAppSelector(allcontentOrConfigData);
  const bannerDisplay = getKeyValuePair(contentOrConfigData, CONTENT_OR_CONFIG_TABLE_MAPPING?.Global?.banner, bannerStringGenerator(_role, _managedEquipment));
  useEffect(() => {
    dispatch(storeContentOrConfig());
    dispatch(changeRedirectUrl(
      getKeyValuePair(
        contentOrConfigData,
        CONTENT_OR_CONFIG_TABLE_MAPPING?.Global?.tableName,
        CONTENT_OR_CONFIG_TABLE_MAPPING?.Global?.REDIRECT_FALLBACK_URL)));
  }, [dispatch]);
  useEffect(() => {
    if (_role === "customerQuote") {
      dispatch(storeBannerData({ role: _role }));
    }
    else if (id) {
      dispatch(storeBannerData({ role: _role, managedEquipment: _managedEquipment }));
    }
  }, [id, _role]);
  return (
    <div className={`${isMobile ? "App portrait" : "App"}`} data-testid="app">
      {loading && <Loader />}
      <Header />
      <div>
        <section className={`${(id || (_mode || _role === "customerQuote")) ? "shipmentId_section" : ""} ${bannerDisplay ? "bannerDisp" : ""}`}>
          {id ? id : (_mode || _role === "customerQuote") ? "Get a quote" : ""}</section>
        <section className='scrollable'>
          <Router />
          <Footer />
        </section>
      </div>
      <ToastContainer
        position="bottom-left"
        hideProgressBar={true}
        theme="dark"
        draggable={false}
        newestOnTop
        autoClose={3000}
        toastClassName="toast"
        limit={2}
      />
    </div>
  );
}

export default App;